module.exports = __webpack_public_path__ + "static/body-8effc00d5d0a24f8ce7d930b60b4ff07.png";